import { createContext } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import appStore from "./stores/AppStore";
import { BrowserRouter } from "react-router-dom";
import authStore from "stores/auth/AuthStore";
import categoryStore from "stores/category/CategoryStore";
import companyStore from "stores/company/CompanyStore";
import depotStore from "stores/depot/DepotStore";
import searchStore from "stores/search/SearchStore";
import subcategoryStore from "stores/subcategory/SubcategoryStore";
import userStore from "stores/user/userStore";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import { ThemeProvider } from "@emotion/react";
import { CssBaseline } from "@mui/material";
import { theme } from "theme";
import productStore from "stores/product/productStore";
import notificationStore from "stores/notification/NotificationStore";
import historyStore from "stores/adminLog/HistoryStore";
import chargeStore from "stores/charge/ChargeStore";
import dashboardStore from "stores/dashboard/dashboardStore";
import stockMovementStore from "stores/stock/stockMovementStore";

export const StoreContext = createContext({
  appStore,
  authStore,
  categoryStore,
  companyStore,
  depotStore,
  searchStore,
  subcategoryStore,
  userStore,
  productStore,
  notificationStore,
  historyStore,
  chargeStore,
  dashboardStore,
  stockMovementStore,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter>
    <StoreContext.Provider
      value={{
        appStore,
        authStore,
        categoryStore,
        companyStore,
        depotStore,
        searchStore,
        subcategoryStore,
        userStore,
        productStore,
        notificationStore,
        historyStore,
        chargeStore,
        dashboardStore,
        stockMovementStore,
      }}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </StoreContext.Provider>
  </BrowserRouter>
);

reportWebVitals();
